import { createContext, useContext, useState, useEffect, useCallback } from "react";

const SidebarContext = createContext({ collapsed: false, toggleSidebar: () => {} });

const STORAGE_KEY = "cv-sidebar-collapsed";

/**
 * Provides sidebar collapsed state + toggle, persisted to localStorage.
 * Wraps AppShell so both DesktopSidebar and content area can react.
 */
export const SidebarProvider = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  // Hydrate from localStorage after mount (avoids SSR mismatch)
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === "true") setCollapsed(true);
    } catch (e) {
      console.warn("[SidebarContext] localStorage read failed:", e.message);
    }
  }, []);

  const toggleSidebar = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(STORAGE_KEY, String(next));
      } catch (e) {
        console.warn("[SidebarContext] localStorage write failed:", e.message);
      }
      return next;
    });
  }, []);

  return (
    <SidebarContext.Provider value={{ collapsed, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
